module.exports = function(fox) {
	'use strict';
	fox.registerWidget('guestDisablePreview', {
		configure: function(options) {
			this.registerOptions('', {
				template: 'guest_preview',
				'widgets.banner': {
					widget: 'Html5Player_MC_Banner',
					'embed.container': '.disable-banner-link'
				}
			});

			this.callParent('configure', arguments);
		},

		beforeRender: function () {
			var dl = this.wom1(this.getOption('dl'));
			var collection = dl.getCollection();
			this.setTemplateOptions(collection[0]);
			this.callParent('beforeRender', arguments);
		}

	}, 'Widget');
}



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/scene/guestDisablePreview.js
// module id = 912
// module chunks = 4